export default {"src":"/_next/static/media/H.49080f97.svg","height":18,"width":18};